import { createCommandEnvelope } from "./command-envelope.js";
import { waitForCommandSettlement } from "./command-settlement.js";
/**
 * Creates a dispatch function that wraps a command payload in an envelope,
 * pushes it into the queue, and returns a promise that settles when the
 * runtime acknowledges it.
 *
 * Request IDs are generated automatically.
 *
 * @example
 * ```ts
 * const dispatch = createCommandDispatch((env) => queue.push(env));
 * await dispatch({ kind: "open", flowId: "f1", flowHandleId: "h1" });
 * ```
 */
export const createCommandDispatch = (push) => {
    const dispatchAndWait = createCommandSettlementDispatch(push);
    return async (input, options) => {
        await dispatchAndWait(input, options);
    };
};
export const createCommandSettlementDispatch = (push) => {
    return async (input, options) => {
        const envelope = createCommandEnvelope({
            command: input,
            idempotencyKey: resolveIdempotencyKey(options?.idempotencyKey) ?? undefined,
        });
        push(envelope);
        return waitForCommandSettlement({ requestId: envelope.requestId });
    };
};
const resolveIdempotencyKey = (value) => {
    if (value === undefined) {
        return null;
    }
    const idempotencyKey = value.trim();
    if (!idempotencyKey) {
        throw new Error("idempotencyKey must be a non-empty string");
    }
    return idempotencyKey;
};
